"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TourBoardTable = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseBasicTable = require("nicbase-basic-table");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _columnDefinition = require("./column-definition");

var _noDataMessage = _interopRequireDefault(require("./no-data-message"));

var _rowRenderer = _interopRequireDefault(require("./row-renderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TourBoardTable = /*#__PURE__*/function (_React$Component) {
  _inherits(TourBoardTable, _React$Component);

  var _super = _createSuper(TourBoardTable);

  function TourBoardTable(props) {
    var _this;

    _classCallCheck(this, TourBoardTable);

    _this = _super.call(this, props);
    _this.state = {};
    _this.onPageChange = _this.onPageChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TourBoardTable, [{
    key: "onPageChange",
    value: function onPageChange(_ref) {
      var pageSize = _ref.pageSize,
          pageNumber = _ref.pageNumber;
      this.props.onPageChange(pageSize, pageNumber);
    }
  }, {
    key: "onDeleteClicked",
    value: function onDeleteClicked(rowId) {
      this.props.onDeleteClicked(rowId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          intl = _this$props.intl,
          visibleColumns = _this$props.visibleColumns,
          selectedTour = _this$props.selectedTour,
          hasPermissions = _this$props.hasPermissions,
          tourStatus = _this$props.tourStatus;
      var version = hasPermissions(['module.tour.extended']) ? 'tourBoardExtended' : 'tourBoardLite';

      if (hasPermissions(['module.tour.rail'])) {
        version = 'rail';
      }

      var columnDefinitions = (0, _columnDefinition.getColumnDefinitionsWithDefaultWidth)(version);
      var colDefs = visibleColumns.map(function (col) {
        return _objectSpread(_objectSpread({}, columnDefinitions[col.dataKey]), col);
      });

      if (!hasPermissions(['module.greenyard.tour'])) {
        colDefs = colDefs.filter(function (column) {
          return column.dataKey !== 'storingPlaces';
        });
      }

      if (!hasPermissions(['module.tour.remainingDrivingTime'])) {
        colDefs = colDefs.filter(function (column) {
          return column.dataKey !== 'remainingDrivingTime';
        });
      }

      if (!hasPermissions(['module.tour.timedStartEnd'])) {
        colDefs = colDefs.filter(function (column) {
          return column.dataKey !== 'scheduledStartTime' && column.dataKey !== 'scheduledEndTime';
        });
      }

      if (hasPermissions(['module.tour.road'])) {
        colDefs = colDefs.filter(function (column) {
          return column.dataKey !== 'train' && column.dataKey !== 'customerName' && column.dataKey !== 'railwayUndertaking' && column.dataKey !== 'loaded';
        });
      }

      if (hasPermissions(['module.tour.rail'])) {
        colDefs = colDefs.filter(function (column) {
          return column.dataKey !== 'customerPortalIds' && column.dataKey !== 'serviceProviderPortalId';
        });
      }

      var columnData = {
        tourStatus: tourStatus,
        onReportExportClicked: this.props.onReportExportClicked,
        useAsTemplate: this.props.useAsTemplate,
        onDetailsClick: this.props.onDetailsClick,
        onEditClick: this.props.onEditClicked,
        onTerminateClick: this.props.onTerminateClicked,
        onStartClick: this.props.onStartClicked,
        onDeleteClick: this.onDeleteClicked.bind(this),
        // props.onDeleteClicked;
        onExportTransportOrderClick: this.props.onExportTransportOrderClick,
        onAssetRequestClick: this.props.onAssetRequestClick
      };
      var selectedRow = data.findIndex(function (row) {
        return row.id === selectedTour;
      });
      return /*#__PURE__*/_react["default"].createElement(_nicbaseBasicTable.TableDesktop, {
        ref: this.props.saveTableRef,
        onPageChange: this.onPageChange,
        onRowClick: this.props.onRowClick,
        data: data,
        totalRows: this.props.count,
        noRowsRenderer: _noDataMessage["default"],
        rowRenderer: _rowRenderer["default"],
        scrollToAlignment: "start",
        onScroll: this.onScroll,
        selectedRows: [selectedRow],
        onColumnReorder: this.props.onColumnReorder,
        onColumnResize: this.props.onColumnResize,
        sort: this.props.onColumnSort,
        sortDirection: this.props.sortDirection,
        sortBy: this.props.sortBy,
        pageSize: 30,
        defaultRowHeight: 54,
        isInfiniteQuery: true,
        showRowCount: true
      }, colDefs.map(function (colDef) {
        if (colDef.dataKey === 'actions') {
          return /*#__PURE__*/_react["default"].createElement(_nicbaseBasicTable.Column, _extends({
            key: colDef.dataKey
          }, colDef, {
            columnData: columnData,
            flexGrow: 0,
            flexShrink: 0,
            label: "".concat(intl.formatMessage({
              id: colDef.label
            }))
          }));
        }

        return /*#__PURE__*/_react["default"].createElement(_nicbaseBasicTable.Column, _extends({
          key: colDef.dataKey
        }, colDef, {
          flexGrow: 0,
          flexShrink: 0,
          label: "".concat(intl.formatMessage({
            id: colDef.label
          }))
        }));
      }));
    }
  }]);

  return TourBoardTable;
}(_react["default"].Component);

exports.TourBoardTable = TourBoardTable;
TourBoardTable.propTypes = {
  portalId: _propTypes["default"].number.isRequired,
  id: _propTypes["default"].string.isRequired,
  isEditActive: _propTypes["default"].bool,
  hasPermissions: _propTypes["default"].func.isRequired,
  selectedTour: _propTypes["default"].number,
  sortBy: _propTypes["default"].string,
  sortDirection: _propTypes["default"].string,
  responsiveMode: _propTypes["default"].shape({
    mode: _propTypes["default"].string
  }),
  visibleColumns: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string
  })),
  count: _propTypes["default"].number,
  intl: _nicbaseTranslation.intlShape.isRequired,
  selectedRow: _propTypes["default"].number,
  useAsTemplate: _propTypes["default"].func,
  onExportTransportOrderClick: _propTypes["default"].func,
  onDetailsClick: _propTypes["default"].func,
  onEditClicked: _propTypes["default"].func,
  onTerminateClicked: _propTypes["default"].func,
  onStartClicked: _propTypes["default"].func,
  onDeleteClicked: _propTypes["default"].func,
  onPageChange: _propTypes["default"].func,
  saveTableRef: _propTypes["default"].func,
  onRowClick: _propTypes["default"].func,
  onColumnReorder: _propTypes["default"].func,
  onColumnResize: _propTypes["default"].func,
  onColumnSort: _propTypes["default"].func,
  onReportExportClicked: _propTypes["default"].func,
  onAssetRequestClick: _propTypes["default"].func,
  tourStatus: _propTypes["default"].shape({})
};

var noop = function noop() {};

TourBoardTable.defaultProps = {
  isEditActive: false,
  sortBy: 'plannedStartTime',
  sortDirection: 'ASC',
  data: [],
  count: 0,
  visibleColumns: [],
  selectedTour: null,
  selectedRow: null,
  tourStatus: {},
  onAssetRequestClick: noop,
  useAsTemplate: noop,
  onExportTransportOrderClick: noop,
  onReportExportClicked: noop,
  onDetailsClick: noop,
  onEditClicked: noop,
  onTerminateClicked: noop,
  onStartClicked: noop,
  onDeleteClicked: noop,
  onPageChange: noop,
  saveTableRef: noop,
  onRowClick: noop,
  onColumnReorder: noop,
  onColumnResize: noop,
  onColumnSort: noop,
  responsiveMode: {
    mode: 'desktop'
  }
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(null)((0, _nicbaseTranslation.injectIntl)(TourBoardTable));

exports["default"] = _default;